/**
 * Monta o payload do modal-esboço de um passo da jornada.
 *
 * Função pura: recebe rótulos, devolve o objeto que vai para `$showModal`.
 * Nada de bus, router ou store aqui — é o que deixa o comportamento testável
 * sem montar componente.
 */
import {
  PASSO_ESBOCO_BOTAO,
  PASSO_ESBOCO_RODAPE,
  PASSO_ESBOCO_TITULO,
} from '@modules/client-journey/constants/Text'

/**
 * @param {Object} opts
 * @param {string} [opts.stepLabel]  nome do passo ("Preenchimento do IPS")
 * @param {string} [opts.stageLabel] nome da etapa que o contém ("Compliance")
 * @returns {Object} payload de $showModal
 */
export function montarModalDePasso({ stepLabel, stageLabel } = {}) {
  const titulo = stepLabel || PASSO_ESBOCO_TITULO
  // A etapa entra como subtítulo, não concatenada no título: o profissional
  // precisa saber ONDE está na jornada, e um título de duas partes some no
  // truncamento do modal.
  const contexto = stageLabel ? `Etapa: ${stageLabel}` : ''
  return {
    title: titulo,
    text: [contexto, PASSO_ESBOCO_RODAPE].filter(Boolean).join('\n\n'),
    center: true,
    buttons: [{ text: PASSO_ESBOCO_BOTAO }],
  }
}
